<template lang="pug">
  .padding-container.create-user
    Notice.success(v-if="success" :top="true") {{ $t('pages.create_user.success') }}
      router-link(:to="'/users/' + success.id") {{ $t('pages.view_users.title') }}
    Notice.success(v-if="success == 'updated'" :top="true") {{ $t('pages.single_user.success') }}
    Notice(v-if="success == 'error'" :top="true") {{ error }}
      router-link(to="/users/view-users") {{ $t('pages.view_users.title') }}
    .details
      .padding
        .flex-grid
          loading(:active.sync="loading")
          div.account
            h4.b-margin-sm {{ $t('pages.create_user.titles.account') }}
            .input-group  
              label {{ $t('fields.email') }}*
              input(v-model="object.email" :placeholder="$t('fields.email')")
            .input-group  
              label {{ $t('fields.name') }}
              input(v-model="object.name" :placeholder="$t('fields.name')")
            .input-group  
              label {{ $t('fields.username') }}*
              input(autocomplete="nope" :readonly="unreadonly" autocorrect="off" autocapitalize="none" spellcheck="false" v-model="object.username" :placeholder="$t('fields.username')")
            .input-group  
              label {{ $t('fields.password') }}*
              input(autocomplete="nope" :readonly="unreadonly" autocorrect="off" autocapitalize="none" spellcheck="false" type="password" v-model="object.password" :placeholder="$t('fields.password')")
            .input-group  
              label {{ $t('fields.phone') }}
              input(v-model="object.business_phone" :placeholder="$t('fields.phone')")
          div.address
            h4.b-margin-sm {{ $t('pages.create_user.titles.address') }}
            .input-group  
              label {{ $t('fields.name') }}
              input(v-model="object.business_name" :placeholder="$t('fields.name')")
            .input-group  
              label {{ $t('fields.phone') }}
              input(v-model="object.business_alt_phone" :placeholder="$t('fields.phone')")
            .input-group  
              label {{ $t('fields.employees') }}
              input(v-model="object.business_employees" type="number" :placeholder="$t('fields.employees')")
            .input-group  
              label {{ $t('fields.address1') }}
              input(v-model="object.business_address1" :placeholder="$t('fields.address1')")
            .input-group  
              label {{ $t('fields.address2') }}
              input(v-model="object.business_address2" :placeholder="$t('fields.address2')")
            .input-group  
              label {{ $t('fields.city') }}
              input(v-model="object.business_city" :placeholder="$t('fields.city')")
            .input-group  
              label {{ $t('fields.postcode') }}
              input(v-model="object.business_postcode" :placeholder="$t('fields.postcode')")
    .details
      .padding
        .flex-grid
          div.roles
            h4.b-margin-sm {{ $t('pages.create_user.titles.options') }}
            .input-group
              label {{ $t('fields.role')}}
              select.select(v-model="object.role")
                option(value="client") {{ $t('roles.client') }}
                option(value="admin") {{ $t('roles.admin') }}
            .input-group
              label {{ $t('fields.active')}}
              select.select(v-model="object.active")
                option(:value="true") True
                option(:value="false") False
            .input-group
              label {{ $t('fields.premium')}}
              select.select(v-model="object.premium")
                option(:value="false") {{ $t('tiers.0') }}
                option(:value="true") {{ $t('tiers.1') }}
    .flex-grid
      .col.mr(v-if="this.isDev()")
        Button(type="dark tick" @click.native="fillAndFinish") Fill Fields
      .col(@click="crudCreate(object, object_form, service)")
        Button(:text="$t('interface.create')")
      .col(@click="$router.back(-1)")
        Button(type="secondary") {{ $t('interface.back') }}
    Notice(v-if="error") {{ error }}

</template>

<script>
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  import UserService from '@/services/user'
  import Notice from '@/components/Notice'

  export default {
    data: function() {
      return {
        service: UserService,
        loading: false,
        success: '',
        error: '',
        unreadonly: true,
        object: {
          email: '',
          username: '',
          password: '',
          name: '',
          role: 'client',
          active: true,
          staff_role: '',
          business_phone: '',
          business_employees: 1,
          business_alt_phone: '',
          business_address1: '',
          business_address2: '',
          business_city: '',
          business_postcode: '',
          premium: false
        },
        object_form: {
          title: this.$t('pages.create_user.prompt_confirm_title'),
          text: this.$t('pages.create_user.prompt_confirm_text')
        }
      }
    },
    methods: {
      changed: function(e) {
        this.object.Groups = e;
      },
      fillAndFinish() {
        this.object = {
          email: 'test@test.com',
          name: 'test',
          username: 'test',
          password: 'password',
          business_phone: '01132506533',
          business_alt_phone: '552525',
          business_name: 'Test Ltd',
          business_employees: 20,
          business_address1: '2 test drive',
          business_address2: 'test',
          business_city: 'test',
          business_postcode: 'test',
          premium: false,
          active: true,
          role: 'client'
        }
        // this.register();
      },
    },
    mounted: function() {
      let item = this;
      
      // Can't believe we have to do this in 2020 to stop a form autofilling..
      setTimeout(function() {
        item.unreadonly = false;
      }, 600)
      
    },
    created() {
      this.$on('loading', function (e) {
        this.loading = e;
      })
      this.$on('error', function (e) {
        console.log('error encountered.. ')
        console.log(e);
        this.error = e;
        this.success = '';
      })
      this.$on('success', function (e) {
        this.success = e.data.user;
        this.loading = false;
        this.error = '';

        let items = Object.keys(this.object);
        items.forEach(item => {
          this.object[item] = '';
        })

        this.object.role = 'client';
        this.object.active = true;
      })
    },
    components: { 
      Loading,
      Notice
    }
  }
</script>

<style lang="scss" scoped>
  .create-user {
    .details {
      border-radius: 5px;
      background:#3d576c;
      margin-bottom:15px;
      max-width:1200px;
      .padding {
        padding:25px;
        h4,label {
          color:#eee;
        }
        h4 {
          border-left:4px solid #eee;
          line-height:45px;
          text-indent:15px;
          font-size:20px;
        }
      }
    }
  }
</style>